module.exports = __webpack_public_path__ + "static/img/img2.f91a822.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2.jpg
// module id = aXrP
// module chunks = 0